<div class="filtros">
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Buscar por nome ou endereço</mat-label>
    <input
      matInput
      [(ngModel)]="filtroNome"
      placeholder="Buscar por nome ou endereço"
      (keyup)="aplicarFiltro()"
    />
  </mat-form-field>
</div>

<div class="lista-estabelecimentos">
  <!-- Mensagem quando não há estabelecimentos -->
  <!-- <div *ngIf="!estabelecimentosExibidos?.length" class="empty-state">
    <p>Nenhum estabelecimento encontrado</p>
  </div> -->

  <!-- Lista de estabelecimentos -->
  <div
    class="estabelecimento-item"
    *ngFor="let estabelecimento of estabelecimentosExibidos"
  >
    <div class="header">
      <img src="../../../../../assets/svg/icons/distance.svg" alt="Ícone de localização" />
      <p>{{ estabelecimento.descricao || 'Nome não disponível' }}</p>
    </div>
    <hr />
    <div class="body">
      <p>{{ getResumoEndereco(estabelecimento) }}</p>
      <p *ngIf="estabelecimento.departamentoRegional">
        <b>Departamento Regional:</b> {{ estabelecimento.departamentoRegional }}
      </p>
      <p *ngIf="estabelecimento.unidadeOperacional">
        Unidade Operacional: {{ estabelecimento.unidadeOperacional }}
      </p>
      <button matButton class="acessar-btn" (click)="acessarEstabelecimento(estabelecimento)">
        Acessar
      </button>
    </div>
  </div>
</div>